module.exports = __webpack_public_path__ + "img/sport.dcd2c3c4.png";